import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { homeGuard } from './core/guards/home.guard';
import { roleGuard } from './core/guards/role.guard';
import { AuditoriaComponent } from './features/admin/auditoria/auditoria';
import { CuentasBancariasComponent } from './features/cuentas-bancarias/cuentas-bancarias';
import { ModulePlaceholderComponent } from './shared/module-placeholder/module-placeholder';
import { NoAutorizadoComponent } from './features/no-autorizado/no-autorizado';
import { EmpresasComponent } from './features/admin/empresas/empresas';
import { PlanesComponent } from './features/admin/planes/planes';
import { UsuariosComponent } from './features/admin/usuarios/usuarios';
import { BancosComponent } from './features/admin/bancos/bancos';
import { ConfiguracionSistemaComponent } from './features/admin/configuracion/configuracion';
import { EmpresaUsuariosComponent } from './features/empresa/usuarios/usuarios';
const rolesConsulta = ['ADMIN_EMPRESA', 'TESORERO', 'ANALISTA_FINANCIERO', 'CONSULTA'];
const rolesOperacion = ['ADMIN_EMPRESA', 'TESORERO', 'ANALISTA_FINANCIERO'];

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login').then((module) => module.LoginComponent),
  },
  {
    path: 'no-autorizado',
    canActivate: [authGuard],
    component: NoAutorizadoComponent,
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/main-layout/main-layout').then((module) => module.MainLayoutComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [homeGuard],
        component: ModulePlaceholderComponent,
      },
      {
        path: 'tesoreria/cuentas',
        component: CuentasBancariasComponent,
        canActivate: [roleGuard],
        data: { roles: rolesConsulta },
      },
      {
        path: 'tesoreria/movimientos',
        canActivate: [roleGuard],
        data: { title: 'Movimientos', roles: rolesConsulta },
        loadComponent: () =>
          import('./features/movimientos/movimientos').then(
            (module) => module.MovimientosComponent,
          ),
      },
      {
        path: 'tesoreria/flujo',
        canActivate: [roleGuard],
        data: { roles: rolesConsulta },
        loadComponent: () =>
          import('./features/flujo-proyectado/flujo-proyectado').then(
            (module) => module.FlujoProyectadoComponent,
          ),
      },
      {
        path: 'tesoreria/amortizaciones',
        canActivate: [roleGuard],
        data: { roles: rolesOperacion },
        loadComponent: () =>
          import('./features/amortizaciones/amortizaciones').then(
            (module) => module.AmortizacionesComponent,
          ),
      },
      {
        path: 'tesoreria/inversiones',
        canActivate: [roleGuard],
        data: { roles: rolesOperacion },
        loadComponent: () =>
          import('./features/inversiones/inversiones').then(
            (module) => module.InversionesComponent,
          ),
      },
      {
        path: 'admin/empresas',
        component: EmpresasComponent,
        canActivate: [roleGuard],
        data: { title: 'Empresas', roles: ['ADMIN'] },
      },
      {
        path: 'admin/usuarios',
        component: UsuariosComponent,
        canActivate: [roleGuard],
        data: { title: 'Usuarios globales', roles: ['ADMIN'] },
      },
      {
        path: 'admin/planes',
        component: PlanesComponent,
        canActivate: [roleGuard],
        data: { title: 'Planes y suscripciones', roles: ['ADMIN'] },
      },
      {
        path: 'admin/bancos',
        component: BancosComponent,
        canActivate: [roleGuard],
        data: { title: 'Bancos e integraciones', roles: ['ADMIN'] },
      },
      {
        path: 'admin/auditoria',
        component: AuditoriaComponent,
        canActivate: [roleGuard],
        data: { title: 'Auditoria global', roles: ['ADMIN'] },
      },
      {
        path: 'admin/configuracion',
        component: ConfiguracionSistemaComponent,
        canActivate: [roleGuard],
        data: { title: 'Configuracion del sistema', roles: ['ADMIN'] },
      },
      {
        path: 'empresa/usuarios',
        component: EmpresaUsuariosComponent,
        canActivate: [roleGuard],
        data: { title: 'Usuarios de la empresa', roles: ['ADMIN_EMPRESA'] },
      },
      {
        path: 'empresa/configuracion-bancaria',
        canActivate: [roleGuard],
        data: { title: 'Configuracion bancaria', roles: ['ADMIN_EMPRESA', 'TESORERO'] },
        loadComponent: () =>
          import('./features/empresa/configuracion-bancaria/configuracion-bancaria').then(
            (module) => module.ConfiguracionBancariaComponent,
          ),
      },
      {
        path: 'empresa/auditoria',
        component: ModulePlaceholderComponent,
        canActivate: [roleGuard],
        data: { title: 'Auditoria de la empresa', roles: ['ADMIN_EMPRESA', 'AUDITOR'] },
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
